// bootstraps the react application
import React from 'react';
import App from './App';

import { createRoot } from 'react-dom/client';

import './index.scss';

// ---------------------------------------------------------------------------
// Stale-chunk reload guard
// When a new deployment invalidates hashed chunk filenames, dynamic imports
// for the old names return 404. Catch that and reload once to fetch fresh assets.
// The sessionStorage flag prevents an infinite reload loop if the chunk is
// genuinely missing for a reason unrelated to deployment.
// ---------------------------------------------------------------------------
window.addEventListener('unhandledrejection', (event) => {
    const msg: string = event.reason?.message ?? '';
    const isChunkError =
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('error loading dynamically imported module') ||
        msg.includes('Importing a module script failed');

    if (isChunkError) {
        const RELOAD_KEY = 'chunk_reload_attempted';
        if (!sessionStorage.getItem(RELOAD_KEY)) {
            sessionStorage.setItem(RELOAD_KEY, '1');
            window.location.reload();
        }
    }
});

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);
root.render(<App />);
